// extracted by mini-css-extract-plugin
export default {"content":"Role_content__sypXJ","header":"Role_header__LEuIX","title":"Role_title__4ajZV"};